import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import account from './modules/account';
import users from './modules/users';
import orders from './modules/orders';
import alert from './modules/alert';
import codeBook from './modules/codeBook';
import acl from './modules/acl';
import templates from './modules/templates';
import translate from './modules/translate';
import patients from './modules/patients';
import applications from './modules/applications';
import reports from './modules/reports';
import notifications from './modules/notifications';
import epicrisis from './modules/epicrisis';
import diseaseClassification from './modules/diseaseClassification';
import indications from './modules/indications';
import applicationPrescriptions from './modules/applicationPrescriptions';
import mails from './modules/mails';
import dataExports from './modules/dataExports';
import service from './modules/service';
import documents from './modules/documents';
import protocols from './modules/protocols';
import log from './modules/log';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        account,
        users,
        orders,
        alert,
        codeBook,
        acl,
        templates,
        translate,
        patients,
        applications,
        reports,
        notifications,
        epicrisis,
        diseaseClassification,
        indications,
        applicationPrescriptions,
        mails,
        dataExports,
        service,
        documents,
        protocols,
        log
    },
    state: {

    }
})



// WEBPACK FOOTER //
// ./src/store/store.js